import { StyledMainSection } from "@/styles/global";
import { Body, TertiaryButtonCss } from "@/styles/typography";
import styled from "styled-components";

const Section = styled(StyledMainSection)``;

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.creme};
  padding: 34px 0;
  width: 100%;
  min-height: 70vh;
`;

const Background = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
`;

const ScrollContainer = styled.div`
  width: 100vw;
  z-index: 10;
`;

const Filters = styled.div`
  overflow: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 10;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 50%;
    overflow: unset;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

const Filter = styled.div<{ $active?: boolean }>`
  padding: 8px 0;
  min-width: max-content;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  opacity: ${({ $active }) =>
    $active === undefined ? 1 : $active === true ? 1 : 0.5};
  position: relative;

  &:first-of-type {
    padding-left: 16px;
  }

  &:last-of-type {
    padding-right: 16px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: max-content;
    margin-bottom: 24px;
    padding: 0;
    &:first-of-type {
      padding-left: 0;
    }

    &:last-of-type {
      padding-right: 0;
    }
  }
`;

const ActiveFilter = styled.div`
  border-radius: 14px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 16px;
  right: 16px;
  z-index: 10;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-height: 45vh;
  overflow: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 11;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: fit-content;
    min-width: 300px;
    left: 0;
    right: 0;
    top: 40px;

    p {
      white-space: nowrap;
    }
  }
`;

const Active = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 4px 12px 6px;
  border-radius: 8px;
  width: max-content;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    transition: all 0.2s ease-in-out;
    margin-bottom: 0;

    &:hover {
      opacity: 0.6;
    }
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 12px;

  div {
    max-width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 32px;
  }
`;

const NumberOfProducts = styled(Body)`
  margin: 0 0 24px 0;
  font-weight: 700;
`;

const Grid = styled.div`
  display: grid;
  gap: 24px 16px;
  grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));
`;

const Card = styled.a`
  display: grid;
  height: fit-content;
  min-height: 100%;
  width: 100%;
  text-decoration: none;
  grid-template-rows: 288px auto;
  border-radius: 14px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.2);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 450px;
  }
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  padding: 0 24px;
  object-fit: contain;
  object-position: center;
  max-width: 100%;
`;

const CardImage = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const TextContainer = styled.div`
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Label = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Details = styled(Body)``;

const DetailsWrapper = styled.div`
  margin: 32px 0 0 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  svg {
    transform: rotate(-45deg);
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
`;

const CurrentDisplayedAmount = styled(Body)``;

const S = {
  Section,
  Wrapper,
  ScrollContainer,
  Filters,
  Filter,
  ActiveFilter,
  Active,
  Background,
  SearchWrapper,
  NumberOfProducts,
  Grid,
  Card,
  Image,
  CardImage,
  TextContainer,
  Label,
  Details,
  DetailsWrapper,
  ButtonWrapper,
  CurrentDisplayedAmount,
};

export default S;
